import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

const SUPER_ADMIN_PASSWORD = process.env.REACT_APP_A3F8C214_9B7E_4D02_B561_E7A930F84C1D || '7f4a2b9e-3c81-4d56-a0f7-e8b5d2196c43';
// ⚠️ Set a3f8c2149b7e4d02b561e7a930f84c1d in Netlify environment variables

export const AuthProvider = ({ children }) => {
  const [superAdmin, setSuperAdmin] = useState(() => sessionStorage.getItem('cc_super') === 'true');
  const [brandAdminSlug, setBrandAdminSlug] = useState(() => sessionStorage.getItem('cc_brand') || null);

  const loginSuperAdmin = (password) => {
    if (password === SUPER_ADMIN_PASSWORD) {
      sessionStorage.setItem('cc_super', 'true');
      setSuperAdmin(true);
      return true;
    }
    return false;
  };

  const loginBrandAdmin = (slug, password, correctPassword) => {
    if (password === correctPassword) {
      sessionStorage.setItem('cc_brand', slug);
      setBrandAdminSlug(slug);
      return true;
    }
    return false;
  };

  const logout = () => {
    sessionStorage.removeItem('cc_super');
    sessionStorage.removeItem('cc_brand');
    setSuperAdmin(false);
    setBrandAdminSlug(null);
  };

  return (
    <AuthContext.Provider value={{ superAdmin, brandAdminSlug, loginSuperAdmin, loginBrandAdmin, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
